var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill-opacity: .9;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,3.1l1.9-1.9c.2-.2.5-.4.9-.4s.6.1.9.4l2,2c.2.2.4.5.4.9s-.1.6-.4.9l-1.6,1.6c.4.8.9,1.6,1.5,2.3.7.7,1.4,1.2,2.3,1.5l1.6-1.6c.2-.2.5-.4.9-.4.2,0,.3,0,.5,0,.1,0,.3.2.4.3l2.1,2c.2.2.4.5.4.9s-.1.6-.4.9l-1.9,1.9c-.4.4-.9.6-1.5.6s-.2,0-.3,0c-2.4-.4-4.7-1.6-6.6-3.5-1.9-1.9-3.1-4.2-3.5-6.6-.1-.7.1-1.4.6-1.8ZM2.2,4.8c.3,2.1,1.5,4.2,3.2,5.9,1.7,1.7,3.8,2.8,5.9,3.2.3,0,.5,0,.7-.2l1.9-1.9-2-2-2.1,2.1h0s-.4-.1-.4-.1c-1.2-.4-2.2-1.1-3.1-2-.9-.9-1.6-1.9-2-3.1v-.4c-.1,0,2-2.2,2-2.2l-2-2-1.9,1.9c-.2.2-.3.5-.2.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.abed221c55894e6b205eb025a63a0c15.svg";
export { ForwardRef as ReactComponent };